module.exports = __webpack_public_path__ + "img/gift-top_bg.67a2740d.png";